var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"landing"},[(!(_vm.$md.phone() && !_vm.$md.tablet()))?_c('hero'):_vm._e(),((_vm.$md.phone() && !_vm.$md.tablet()))?_c('mobile-hero'):_vm._e(),_c('about'),_c('contact')],1)}
var staticRenderFns = []

export { render, staticRenderFns }